{
  "comu": {
    "revisaErrors": "Revisa los campos marcados en rojo"
  },
  "zones": {
    "cerca": "Buscar por nombre, código o dirección…",
    "inactives_one": "Mostrar inactivas ({{count}})",
    "inactives_other": "Mostrar inactivas ({{count}})",
    "buit": "Todavía no hay ninguna zona. Crea la primera con «Nueva zona».",
    "senseResultats": "Ninguna zona coincide con «{{q}}».",
    "totesInactives": "Todas las zonas están inactivas. Activa «Mostrar inactivas» para verlas.",
    "novaEtiqueta": "Nueva zona",
    "dins": "Se creará dentro de",
    "crea": "Crear la zona",
    "codiFix": "Código corto y único. Una vez creada la zona no se podrá cambiar.",
    "codiBloquejat": "El código no se puede cambiar porque otros registros hacen referencia a él.",
    "ajudaActiu": "Una zona inactiva no se puede elegir en activaciones nuevas.",
    "plega": "Plegar {{nom}}",
    "desplega": "Desplegar {{nom}}",
    "afegeixDins": "Añadir una zona dentro de {{nom}}",
    "nFills_one": "{{count}} zona",
    "nFills_other": "{{count}} zonas"
  },
  "integracions": {
    "integracio": "Integración",
    "totesOk": "Todas las integraciones funcionan",
    "ambProblemes_one": "{{count}} integración con problemas",
    "ambProblemes_other": "{{count}} integraciones con problemas",
    "errorMonitoratge": "No se ha podido consultar el estado de las integraciones. Vuelve a probar con «Comprobar ahora».",
    "rendiment": "Rendimiento de los envíos",
    "senseDades": "Todavía no hay datos de monitorización.",
    "configuracio": "Cómo está configurada cada integración",
    "senseConfigurar_one": "{{count}} integración sin configurar",
    "senseConfigurar_other": "{{count}} integraciones sin configurar"
  },
  "versions": {
    "pestanyaVersions": "Versiones",
    "darrera": "Última publicada",
    "minima": "Mínima obligatoria",
    "formatVersio": "La versión debe tener el formato 2, 2.4 o 2.4.1.",
    "rangInvalid": "La versión inicial debe ser anterior o igual a la final.",
    "ajudaMinima": "Las apps con una versión anterior tendrán que actualizarse para seguir funcionando.",
    "definitiva": "Una versión publicada no se puede modificar ni borrar: revísala antes de publicar.",
    "plataformes": "Plataformas",
    "desde": "Visible desde",
    "fins": "Visible hasta",
    "datesInvalides": "La fecha final debe ser posterior a la inicial.",
    "ajudaVigencia": "Deja las fechas vacías para que el mensaje se muestre siempre mientras esté activo.",
    "triaMissatge": "Elige un mensaje para ver cómo se muestra en la app.",
    "eliminaTitol": "Eliminar el mensaje",
    "eliminaText": "El mensaje «{{titol}}» dejará de mostrarse en la app y se eliminará. Si solo quieres pararlo, desactívalo."
  },
  "configuracio": {
    "pestanyes": {
      "ajustos": "Configuración",
      "historial": "Historial de cambios"
    },
    "regional": "Regional",
    "escalat": "Escalado",
    "ajudaEscalat": "Se aplica a los niveles de circuito que no tienen espera propia. Cada nivel puede tener su tiempo y cada tipo de aviso, su tiempo de confirmación:",
    "fusos": {
      "Europe_Madrid": "Península y Baleares",
      "Atlantic_Canary": "Canarias",
      "UTC": "Tiempo universal (UTC)"
    }
  },
  "politica": {
    "ajudaFormats": "Solo se podrán subir ficheros de estos formatos.",
    "midaInvalida": "Indica un tamaño entre 1 y 500 MB.",
    "maxInvalid": "Indica un número entero entre 1 y 1.000.",
    "sempre": "Siempre se aplica, sea cual sea la configuración",
    "noDisponibles": "Ficheros no disponibles"
  },
  "documents": {
    "cerca": "Buscar por título, código o categoría…",
    "filtraAmbit": "Filtrar por departamento, área o servicio…",
    "treuAmbit": "Quitar el filtro de ámbito",
    "totsFormats": "Todos los formatos",
    "document": "Documento",
    "perA": "Para",
    "senseResultats": "Ningún documento coincide con los filtros.",
    "noObrible": "El fichero no se puede consultar; abre la ficha para ver el motivo.",
    "noDescarregable": "No se puede consultar ni descargar",
    "nDocuments_one": "{{count}} documento",
    "nDocuments_other": "{{count}} documentos",
    "perQui": "¿Para quién es?",
    "triaServei": "Elige el servicio…",
    "quiConsulta": "Quién lo puede consultar",
    "ambit": {
      "SERVEI": "Solo el servicio",
      "AREA": "Toda el área",
      "DEPARTAMENT": "Todo el departamento"
    },
    "ambitFrase": {
      "SERVEI": "Solo el servicio {{nom}}",
      "AREA": "Toda el área {{nom}}",
      "DEPARTAMENT": "Todo el departamento {{nom}}"
    },
    "ambitAjuda": {
      "SERVEI": "Lo ven las personas con acceso a este servicio.",
      "AREA": "Lo ven las personas con acceso a cualquier servicio del área.",
      "DEPARTAMENT": "Lo ven las personas con acceso a cualquier área del departamento."
    },
    "ajudaDescarrega": "Lo decide la política de ficheros; si no, solo se puede consultar con marca de agua.",
    "fitxerIDades": "Fichero y datos",
    "ajudaTitol": "Si dejas el título vacío, se usará el nombre del fichero.",
    "categoriaPlaceholder": "p. ej. Procedimiento, Contactos…",
    "comentariPlaceholder": "Qué ha cambiado en esta versión (opcional)",
    "novaVersioDe": "La versión nueva sustituirá a la vigente ({{versio}}) cuando supere el análisis antimalware.",
    "resultat": "«{{titol}}» se ha subido. Se publicará automáticamente cuando supere el análisis antimalware.",
    "obreDocument": "Abrir el documento",
    "pestanyes": {
      "dades": "Datos",
      "versions": "Versiones",
      "acces": "Acceso",
      "activitat": "Actividad"
    },
    "senseResponsable": "Sin responsable",
    "retiratNoEditable": "Un documento retirado no se puede editar. Restáuralo para volver a publicarlo.",
    "senseEdicio": "No tienes permiso para modificar este documento.",
    "restaura": "Restaurar",
    "restauraNoDisponible": "La restauración de documentos todavía no está disponible.",
    "retiraTitol": "Retirar «{{titol}}»",
    "retiraText": "El documento dejará de estar disponible en las activaciones. El historial se conserva y podrás restaurarlo.",
    "que": "Qué",
    "mesActivitat": "Mostrar más"
  }
}
